(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('ValidationCtrl', validationCtrl);

    function validationCtrl($scope, $rootScope, $location, UsersAPIService) {
        $rootScope.showHeader = false;
        $scope.verificationComplete = false;
        $scope.verificationError = false;

        var token = $location.search().token;
        if (!token) {
            $scope.verificationError = true;
        } else {
            let verificationTimeout;
            const verifyUser = () => {
                UsersAPIService.verifyUser(token)
                    .then(function (status) {
                        if (status === 'Succeeded') {
                            $scope.verificationComplete = true;
                            clearTimeout(verificationTimeout);
                        } else if (status === 'Failed') {
                            $scope.verificationError = true;
                            clearTimeout(verificationTimeout);
                        } else {
                            setTimeout(verifyUser, 2000);
                        }
                    })
                    .catch(function () {
                        $scope.verificationError = true;
                        clearTimeout(verificationTimeout);
                    });
            };
            verifyUser();
        }

        $scope.goToLogin = function () {
            $location.path('/signin');
        };
    }
})();
